import React, { useState } from "react";
import "./ReportBox.css";
import moment from "jalali-moment";
import { BsCheckLg, BsPlusSquare } from "react-icons/bs";
import { RiUploadCloudLine } from "react-icons/ri";
import { BiGlasses, BiTrash } from "react-icons/bi";
import { HiOutlinePencilAlt } from "react-icons/hi";

function ReportBox(props) {
    const [tick, setTick] = useState(false);
    return (
        <div className="BuildingBox" style={{ display: "flex" }}>
            <div className="BuildingBoxItem1" style={{ flexGrow: 1 }}>
                <div className="SCheckboxTick BuildingBoxItem1Tick" onClick={() => setTick(!tick)}>
                    {tick ? <BsCheckLg /> : <></>}
                </div>
                <span className="BuildingBoxItemTitle BuildingBoxItemTitle1">{props.index + 1}</span>
            </div>

            <div className="BuildingBoxItem2" style={{ flexGrow: 3, minWidth: "200px" }}>
                <span className="BuildingBoxItemTitle">{props.data.id}</span>
            </div>
            <div className="BuildingBoxItem3" style={{ flexGrow: 2 }}>
                <span className="BuildingBoxItemTitle">{props.data.fullName}</span>
            </div>
            <div className="BuildingBoxItem4" style={{ flexGrow: 2 }}>
                <span className="BuildingBoxItemTitle">{props.data.expertName}</span>
            </div>
            <div className="BuildingBoxItem5" style={{ flexGrow: 2 }}>
                {!props.data.sazande ? (
                    <span className="BuildingBoxItemTitle" style={{ color: "#485460", padding: "6px 18px", borderRadius: "12px" }}>
                        ------
                    </span>
                ) : (
                    <span className="BuildingBoxItemTitle" style={{ color: "#575fcf", padding: "6px 18px", borderRadius: "12px" }}>
                        سازنده
                    </span>
                )}
                <span className="BuildingBoxItemTitle">{props.data.sazande}</span>
            </div>
            <div className="BuildingBoxItem7" style={{ flexGrow: 2 }}>
                {(() => {
                    if (!props.data.status || props.data.status == "new") {
                        return (
                            <span className="BuildingBoxItemTitle" style={{ backgroundColor: "#0fbcf9", color: "snow", padding: "6px 18px", borderRadius: "12px" }}>
                                جدید
                            </span>
                        );
                    } else if (props.data.status == "erja") {
                        return (
                            <span className="BuildingBoxItemTitle" style={{ backgroundColor: "#ffa801", color: "snow", padding: "6px 18px", borderRadius: "12px" }}>
                                ارجاع شده
                            </span>
                        );
                    } else if (props.data.status == "inprogress") {
                        return (
                            <span className="BuildingBoxItemTitle" style={{ backgroundColor: "#f53b57", color: "snow", padding: "6px 18px", borderRadius: "12px" }}>
                                درحال ارزیابی
                            </span>
                        );
                    } else {
                        return (
                            <span className="BuildingBoxItemTitle" style={{ backgroundColor: "#05c46b", color: "snow", padding: "6px 18px", borderRadius: "12px" }}>
                                تکمیل شده
                            </span>
                        );
                    }
                })()}
            </div>
            <div className="BuildingBoxItem7" style={{ flexGrow: 2 }}>
                {(() => {
                    if (!props.data.paidType || props.data.paidType == "") {
                        return (
                            <span className="BuildingBoxItemTitle" style={{ color: "#3B3B98", padding: "6px 18px", borderRadius: "12px" }}>
                                پرداخت نشده
                            </span>
                        );
                    } else if (props.data.status == "erja") {
                        return (
                            <span className="BuildingBoxItemTitle" style={{ color: "#3B3B98", padding: "6px 18px", borderRadius: "12px" }}>
                                پرداخت آنلاین
                            </span>
                        );
                    } else if (props.data.status == "inprogress") {
                        return (
                            <span className="BuildingBoxItemTitle" style={{ color: "#3B3B98", padding: "6px 18px", borderRadius: "12px" }}>
                                پرداخت نقدی
                            </span>
                        );
                    } else {
                        return (
                            <span className="BuildingBoxItemTitle" style={{ color: "#3B3B98", padding: "6px 18px", borderRadius: "12px" }}>
                                واریزی
                            </span>
                        );
                    }
                })()}
            </div>

            <div className="BuildingBoxItem8" style={{ flexGrow: 2 }}>
                <div className="BuildingBoxItem8Icons">
                    <div className="BuildingBoxItem8Icon">
                        <RiUploadCloudLine />
                    </div>
                    <div className="BuildingBoxItem8Icon">
                        <BiGlasses />
                    </div>
                    <div className="BuildingBoxItem8Icon BuildingBoxItem8IconLast">
                        <BiTrash />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ReportBox;
